import { Component, OnInit, OnDestroy, ViewChild, Input, Output, OnChanges, SimpleChange, AfterViewInit, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup }                 from '@angular/forms';
import { NgForm } from '@angular/forms';
import { SeguridadService } from '../_services/seguridad.service'
import { Subscription } from 'rxjs/Subscription';

import {GlobalEventsManager} from "../_services/globaleventsmanager.service";

import { CuestionarioService } from "../_services/cuestionario.service";

import { Nivel } from '../_models/nivel.model';
import { Pregunta } from '../_models/pregunta.model';

import { EvidenciasService } from '../_services/evidencias.service';
import { ModalDirective } from 'ng2-bootstrap/modal';

declare var jQuery: any;

@Component({
  selector: 'modalevidencias',
  templateUrl: 'modalevidencias.template.html'
})
export class ModalEvidenciasComponent  implements OnInit, OnDestroy, OnChanges, AfterViewInit{

  @Input() _id_respuesta: any;
  @Input() _mostrarmodal: any;
  @Input() _id_cuestionario: number;
  @Input() _listaevidenciasiniciales: any;
  @ViewChild('staticModalRespuestas') public staticModalRespuestas:ModalDirective;
  @Output() onChangeModal = new EventEmitter<any>();
  @Input() _evidenciasfijas: boolean;
  @Input() _evidenciascuestionario: boolean;

  public filterQuery = "";
  public filterQueryEvidencias = "";

  id_respuesta: number;
  id_cuestionario: number;
  mostrarmodal: boolean = false;
  listaevidencias: any = [];
  listaevidenciasseleccionadas: any = [];
  listaevidenciasiniciales: any = [];
  sortby: string = "";
  sortdirection: string = "desc";
  evidenciasfijas: boolean = false;
  
  evidenciascuestionario: boolean = false;
  verEvidenciaInfo: boolean = false;
  id_evidencia_info: number;

  listaniveldeseguridad: any;
  listamodulosevidencias: any;
  listaafectapersonalmaquinaria: any;
  listaasignacion: any;
  listanivelelemento: any;
  listanivelseguridad: any;
  listatipocomentario: any;
  listatiposancion: any;
  listaenlacesnorma: any;

  listaEvidenciasFiltro:any = [];
  mostrarFiltros:boolean = false;

  constructor(private seguridad: SeguridadService,
              private router:Router,
              private cuestionarioService: CuestionarioService,
              private globalEventsManager: GlobalEventsManager,
              private evidenciasService: EvidenciasService,
              private activatedRoute: ActivatedRoute){

  }

  ngOnChanges(changes: {[ propName: string]: SimpleChange}){
    if (changes['_id_respuesta']){
      this.id_respuesta = changes['_id_respuesta'].currentValue;
    }
    if (changes['_mostrarmodal']){
      this.mostrarmodal = changes['_mostrarmodal'].currentValue;
    }
    if (changes['_evidenciasfijas']){
      this.evidenciasfijas = changes['_evidenciasfijas'].currentValue;
    }
    if (changes['_evidenciascuestionario']){
      this.evidenciascuestionario = changes['_evidenciascuestionario'].currentValue;
    }
    if (changes['_id_cuestionario']){
      this.id_cuestionario = changes['_id_cuestionario'].currentValue;

    }
    if (changes['_listaevidenciasiniciales']){
      this.listaevidenciasiniciales = changes['_listaevidenciasiniciales'].currentValue;

      //console.log(this.listaevidenciasiniciales);
    }
    
    this.getListaEvidencias();
  }

  ngOnInit(){
/*
    this.getLista("ListagetModuloEvidencias");
    this.getLista("ListagetEvidenciaAPERMAQ");
    this.getLista("ListagetEvidenciaAsignacion");
    this.getLista("ListagetEvidenciaNivelElemento");
    this.getLista("ListagetEvidenciaNivelSeguridad");
    this.getLista("ListagetEvidenciaComentarioTipo");
    this.getLista("ListagetTipoSancion");
*/
  }

  ngOnDestroy(){

  }

  ngAfterViewInit(){
    this.abrirModal();

  }

  getListaEvidencias() {

    if(this.evidenciasfijas){

      this.getTodasEvidenciasModulo();

    }else{

        if (this.evidenciascuestionario){

          console.log("entro");

          this.cuestionarioService.getListaEvidenciasCuestionario(this.id_cuestionario).subscribe(
              data => {
                if (data){

                  console.log(data.json());

                  this.listaevidencias = data.json().evidencias;
                  this.listaEvidenciasFiltro = data.json().evidencias;
                  
                  setTimeout(() => this.inicializarEvidenciasSeleccionadas(), 500);
                }
              }
          );

        }else{

          this.cuestionarioService.getListaEvidencias(this.id_cuestionario).subscribe(
              data => {
                if (data){
                  
                  this.listaevidencias = data.json().evidencias;

                  setTimeout(() => this.inicializarEvidenciasSeleccionadas(), 500);
                }
              }
          );

        }
    }

  }

  abrirModal(){
    if (this.mostrarmodal){
      this.staticModalRespuestas.show();
    }
  }

  cerrarModal(){
    this.staticModalRespuestas.hide();
    this.onChangeModal.emit(this.listaevidenciasseleccionadas);
  }

  anadirEvidencia(evidencia: any, event: any){

    let encontrado: number;

    if (jQuery('#check_'+event).is(':checked')) {
      this.listaevidenciasseleccionadas.push(evidencia);
    }else{
      for (let i = 0; i < this.listaevidenciasseleccionadas.length; i++) {
        if (this.listaevidenciasseleccionadas[i].id_evidencia == evidencia.id_evidencia){

          encontrado = i;
        }

      }

      this.listaevidenciasseleccionadas.splice(encontrado,1);
    }

    let al: any = {
      "texto" : "Evidencias modificadas",
      "mostrar": true
    };
    this.globalEventsManager.setAlert(al);

    //console.log(this.listaevidenciasseleccionadas);
  }



  comprobarCheck(){
    for (let i = 0; i < this.listaevidenciasseleccionadas.length; i++) {

        jQuery('#check_'+this.listaevidenciasseleccionadas[i].id_evidencia).prop("checked", true);

    }
  }

  inicializarEvidenciasSeleccionadas(){

    //jQuery('#check_10').hide();
    console.log(this.listaevidenciasiniciales);

    let algunoseleccionado: string = "no";

    for (let i = 0; i < this.listaevidencias.length; i++) {
      this.listaevidencias[i].selected = "no";
    }

    for (let i = 0; i < this.listaevidencias.length; i++) {
      for (let f = 0; f < this.listaevidenciasiniciales.length; f++) {

        //console.log(this.listaevidencias[i].id_evidencia);

        if (this.listaevidencias[i].id_evidencia == this.listaevidenciasiniciales[f].id_evidencia){

          algunoseleccionado = "si";

          this.listaevidencias[i].selected = "si";

          this.listaevidenciasseleccionadas.push(this.listaevidencias[i]);
          //console.log(this.listaevidencias[i].id_evidencia);
          jQuery('#check_'+this.listaevidencias[i].id_evidencia).prop("checked", true);

        }
      }
    }

    if (algunoseleccionado == "si"){
      this.sortby = "selected";
      this.sortdirection = "desc";
    }

    setTimeout(() => this.comprobarCheck(), 100);

    console.log(this.listaevidencias);
  }


  getTodasEvidenciasModulo(){

    this.cuestionarioService.getListaEvidenciasModulo(this.id_cuestionario).subscribe(
      data => {
        if (data){

          this.listaevidencias = data.json().evidencias;
          this.listaEvidenciasFiltro = data.json().evidencias;
          this.cuestionarioService.getCuestionarioListaEvidenciasFijas(this.id_cuestionario).subscribe(
            data => {
              
              this.listaevidenciasiniciales = data.json().evidencias;
              setTimeout(() => this.inicializarEvidenciasSeleccionadas(), 500);
            }
          )                                
          
        }
      }
    )


  }

  anadiraEvidenciaFija(evidencia:any, event:any){


    let encontrado: number;

    if (jQuery('#check_'+event).is(':checked')) {

      this.insertarEvidenciaFija(this.id_cuestionario,event);
      this.listaevidenciasseleccionadas.push(evidencia);
    }else{

      this.eliminarEvidenciaFija(this.id_cuestionario,event);
      for (let i = 0; i < this.listaevidenciasseleccionadas.length; i++) {
        if (this.listaevidenciasseleccionadas[i].id_evidencia == evidencia.id_evidencia){

          encontrado = i;
        }

      }

      this.listaevidenciasseleccionadas.splice(encontrado,1);
    }


    console.log(this.listaevidenciasseleccionadas);    
  }





  //- Insertamos las evidencias fijas al entrar por primera vez
  insertarInicioCuestionarioEvidenciasFijas(){

    this.cuestionarioService.getListaEvidenciasFijas(this.id_cuestionario).subscribe(
      data => {
        if (data){

          this.listaevidencias = data.json().evidencias;
          for (let evi of this.listaevidencias){
            this.cuestionarioService.setEvidenciasFijas(this.id_cuestionario,evi.id_evidencia).subscribe(
              dta => {

              }
            );
           
          }

        }
      }
    );

  }
  

 insertarEvidenciaFija(id_cuestionario:number,id_evidencia:number){

    this.cuestionarioService.setEvidenciasFijas(id_cuestionario,id_evidencia).subscribe(
      data => {}
    )

 }


 eliminarEvidenciaFija(id_cuestionario:number,id_evidencia:number){

  this.cuestionarioService.deleteEvidenciasFijas(id_cuestionario,id_evidencia).subscribe(
    data => {}
  )

}

mostrarEvidenciaInfo(id_evidencia:number){
  this.id_evidencia_info = id_evidencia;
  this.verEvidenciaInfo = true;
    
}

cerrarInfoModal(){

  this.verEvidenciaInfo = false;
  setTimeout(() => this.inicializarEvidenciasSeleccionadas(), 500);

}

/*

getLista(accion: string){
  this.evidenciasService.getLista(accion).subscribe(
    data => {
      if (data){

        let json = data.json();

        if (accion == ""){
          this.listaniveldeseguridad = json.lista;
        }
        if (accion == "ListagetModuloEvidencias"){
          this.listamodulosevidencias = json.lista;

        }
        if (accion == "ListagetEvidenciaAPERMAQ"){
          this.listaafectapersonalmaquinaria = json.lista;
        }
        if (accion == "ListagetEvidenciaAsignacion"){
          this.listaasignacion = json.lista;
        }
        if (accion == "ListagetEvidenciaNivelElemento"){
          this.listanivelelemento = json.lista;
        }
        if (accion == "ListagetEvidenciaNivelSeguridad"){
          this.listanivelseguridad = json.lista;
        }
        if (accion == "ListagetEvidenciaComentarioTipo"){
          this.listatipocomentario = json.lista;
        }
        if (accion == "ListagetTipoSancion"){
          this.listatiposancion = json.lista;
        }
      }
    }
  );
}




filtrarLista(value,tipo){

 // this.listaEvidenciasFiltro = Object.assign({}, this.listaevidencias);

  if (tipo == 'modev'){
    this.listaevidencias =  this.listaevidencias.filter(
      item => item.id_modev.indexOf(value.toLowerCase()) > -1
    )
  }
  if (tipo == 'explicito'){
    this.listaevidencias =  this.listaevidencias.filter(
      item => item.modoexplicito.indexOf(value.toLowerCase()) > -1
    )
  }  
  if (tipo == 'persmaq'){
    this.listaevidencias =  this.listaevidencias.filter(
      item => item.id_persmaq.indexOf(value.toLowerCase()) > -1
    )
  }   
  if (tipo == 'periodicidadtipo'){
    this.listaevidencias =  this.listaevidencias.filter(
      item => item.periodicidadtipo.indexOf(value.toLowerCase()) > -1
    )
  }    
  if (tipo == 'asignacion'){
    this.listaevidencias =  this.listaevidencias.filter(
      item => item.id_asignacion.indexOf(value.toLowerCase()) > -1
    )
  }   
  if (tipo == 'nivelelemento'){
    this.listaevidencias =  this.listaevidencias.filter(
      item => item.id_nivelelemento.indexOf(value.toLowerCase()) > -1
    )
  }   

  if (tipo == 'sancion'){
    this.listaevidencias =  this.listaevidencias.filter(
      item => item.id_tipo_sancion.indexOf(value.toLowerCase()) > -1
    )
  }    

}

limpiarFiltros(){
 
  this.getListaEvidencias();

}

*/
//---------------------------------------------------------------------
//-                            FILTROS
//---------------------------------------------------------------------
   
limpiarFiltros(){

  this.getListaEvidencias();

  this.globalEventsManager.getEvidenciasSinRelacionar(this.id_cuestionario);


}

changeValueEvidenciaFiltros(filtro){

 this.listaevidencias = filtro;
 if (filtro.tipo == 'limpiar' ){
   this.limpiarFiltros();      
 }else{
   this.listaevidencias = filtro.value;

 }

 }
}



// WEBPACK FOOTER //
// ./src/app/cuestionario/modalevidencias.component.ts